export default "\r\n<button (click)=\"clikka($event)\">clikka</button>\r\n\r\n<app-nica-tabs name=\"tabs2\"></app-nica-tabs>\r\n\r\n"